export default __webpack_public_path__ + "static/media/mon_256.52a15a01.png";